import React from 'react';
import { Flyer } from '@/graphql/types';
import styles from './DayCard.styles';
import FlyerCard from '../FlyerCard/FlyerCard';

interface DayCardProps {
  trackId?: string;
  stickyTop: number;
  weekDay: string;
  day: string;
  flyers: Array<Flyer>;
}

export const DayCard: React.FC<DayCardProps> = ({ trackId, stickyTop, day, weekDay, flyers }) => (
  <div className={styles.container} key={weekDay}>
    <div
      className={styles.stickyDay}
      style={{ top: `${stickyTop + 40}px` }}
      data-testid="stickyDayContainer"
    >
      <div className={styles.dayContainer}>
        <span className={styles.weekday} data-testid="weekDay">
          {weekDay}
        </span>
        <span className={styles.day} data-testid="day">
          {day}
        </span>
      </div>
    </div>
    <div className={styles.cards}>
      {flyers.map(flyer => (
        <FlyerCard flyer={flyer} trackId={trackId} key={flyer.flyerId} />
      ))}
    </div>
  </div>
);
